export function useAgencyTheme() {
    const setTheme = (user) => {
        let brandColor = '#ef5455';
        if (user?.agency?.theme_color) {
            brandColor = user.agency.theme_color;
        }

        document.querySelector(':root').style.setProperty('--brand-color', brandColor)
    }

    return { setTheme };
}
